import { render, staticRenderFns } from "./crudStoreDiscounts.vue?vue&type=template&id=08653230&"
import script from "./crudStoreDiscounts.vue?vue&type=script&lang=js&"
export * from "./crudStoreDiscounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports